export default {
    txt_welcome: 'Selamat Datang',
    txt_dataover: 'Gambaran keseluruhan',
    txt_chance: 'Pemimpin jualan',
    txt_device: 'Peranti',
    txt_chinese: '中文-Chinese',
    txt_english: '英文-English',
    txt_malay: '马来语-Malay',
    txt_reports: 'Sejarah',
    txt_setting: 'Tetapan',
    txt_dymanager: 'Pekerja',
    txt_account: 'ID Akaun',
    txt_userstatus: 'Identiti pengguna',
    txt_name: 'Nama',
    txt_contactway: 'Telefon',
    txt_accountsafe: 'Kontosicherheit',
    txt_basicinfo: 'Maklumat asas',
    txt_updatepassword: 'Ubah suai kata laluan',
    txt_storeinfomation: 'Menyimpan maklumat',
    txt_storename: 'Nama kedai',
    txt_storephone: 'Nombor telefon',
    txt_wheelalignment: 'Need to do dynamic balance and wheel alignment',
    txt_storeaddress: 'Alamat kedai',
    txt_AppInfomation: 'Aplikasi',
    txt_currentversion: 'Versi semasa',
    txt_software: 'Kemas kini perisian',
    txt_loginout: 'Log keluar',
    txt_updatelanguage: 'Bahasa',
    txt_updateto: 'Kemaskini ke ',
    txt_zwgx: 'Kein Update',
    txt_dz: 'Pengurus',
    txt_sh: 'Saudagar',
    txt_dy: 'Pekerja',
    txt_bdsj: 'Telefon bimbit mengikat',
    txt_shxx: 'Maklumat perniagaan',
    txt_shname: 'Nama saudagar',
    txt_ssmd: 'Kedai',
    txt_bdsb: 'Mengikat',
    txt_mendian: 'Kedai',


    //数据总览模块
    txt_sTime: 'Pilih masa',
    txt_car_check: 'Kadar pemeriksaan',
    txt_findchance: 'Pemimpin jualan',
    txt_trackchace: 'Kadar pengesanan',
    txt_transform: 'Kadar penukaran',
    txt_TotalData: 'Gambaran keseluruhan',
    txt_xxsj: 'Data terperinci',
    txt_zhsj: 'Data penukaran',
    txt_TireWear: 'Pakai tayar',
    txt_DataHopper: 'Corong',
    txt_jdcc: 'Trafik kereta',
    txt_CheckCar: 'Imbasan',
    txt_ChanceNum: 'Peluang',
    txt_TrackNum: 'Penjejakan',
    txt_TranseformNum: 'Penukaran',
    txt_UnTrack: 'Tidak dijejaki',
    txt_l: 'Kenderaan',
    txt_Time: 'Masa',
    txt_Device: 'Peranti',
    txt_car_plate: 'Nombor lesen',
    txt_Wear: 'Memakai',
    txt_Pwear: 'Tidak Sekata',
    txt_NoData: 'Keine Daten',
    txt_GoodState: 'Normal',
    txt_Border: 'Sempadan',
    txt_replace: 'Ganti',
    txt_Total_Check: 'Insgesamt',
    txt_pmqk: 'Tidak Sekata',
    txt_LightWear: 'Pakai tidak sekata(Sedikit)',
    txt_GraveWear: 'Pakai tidak sekata(Serius)',
    txt_hwtj: 'Putaran',
    txt_wxhw: 'Tidak perlu putaran tayar.',
    txt_xyhw: 'Perlu putaran tayar',
    txt_jcxq: 'Butiran',
    txt_zhxq: 'Penukaran derail',
    txt_cc: 'Kenderaan',
    txt_bfb: '%',
    txt_ltxs: 'Jualan tayar',
    txt_sldw: 'Penjajaran',
    txt_ddlph: 'Baki',
    txt_dphhh: 'Baki',
    txt_qt: 'Lain-lain',
    txt_zhqs: 'Trend Penukaran',
    txt_ltxl: 'Jualan Tayar',
    txt_ltfw: 'Perkhidmatan tayar',
    txt_ckxq: 'Butiran',
    txt_jt: 'Hari ini',
    txt_zt: 'Semalam',
    txt_bz: 'Minggu',
    txt_by: 'Bulan',
    txt_sy: 'Bulan lepas',
    txt_jn: 'Tahun',
    txt_zhcl: 'kuantiti (Unit)',
    txt_zhl: 'Kadar(%)',
    txt_bfb: '%',
    txt_abjx: 'Pengagihan kenderaan "Keadaan sempadan"',
    txt_aljg: 'Pengagihan kenderaan "Gantikan segera',
    txt_qwpm: 'Pengedaran kenderaan "Haus tidak sekata"',
    txt_ayzp: 'Pengagihan kenderaan "Tayar haus tidak sekata yang serius"',
    txt_lingt: '0 Tayar',
    txt_yt: '1 Tayar',
    txt_et: '2 Tayar',
    txt_st: '3 Tayar',
    txt_ft: '4 Tayar',

    //机会
    txt_xsjh: 'Jualan petunjuk',
    txt_gzz: 'Penjejakan',
    txt_clwb: 'Tutup',
    txt_ckbg: 'Laporan',
    txt_yxs: 'Semua data dipaparkan',
    txt_zhuiz: 'Peringatan',
    txt_tix: 'Ingatkan',
    txt_chuli: 'Operasi',
    txt_yzh: 'Ditukar',
    txt_wzh: 'Tidak ditukar',
    txt_gzsmts: 'Masalah pemeriksaan {0}, {1} dijangka datang ke kedai untuk pembaikan',
    txt_czbty: 'Tidak bersetuju',
    txt_yyx: 'Tujuan',
    txt_ltyg: '1 Tayar',
    txt_ltkg: '2 Tayar',
    txt_ltsang: '3 Tayar',
    txt_ltsig: '4 Tayar',
    txt_jhcl: 'Prozess',
    txt_jhztai: 'Negeri',
    txt_crquy: 'Wilayah',
    txt_chuliry: 'Pemproses',
    txt_chulijg: 'Keputusan',
    txt_zhuanhuanr: 'Kandungan',
    txt_zhuanhuaje: 'Pendapatan',
    txt_zhuanhuasj: 'Masa',
    txt_zhuanhuayx: 'Jadual',
    txt_xuanzesj: 'Pilih masa',
    txt_tsdatawk: 'Daten können nicht gespeichert werden, wenn der verkaufsführende Status leer ist',
    txt_qtxzhsj: 'Isikan masa Jadual',
    txt_qtxzhnr: 'Sila isikan kandungan penukaran',
    txt_qtxzhsj: 'Sila isikan masa penukaran',
    txt_sbts: 'Penjimatan data gagal, sila semak rangkaian',


    //设备
    txt_sbgl: 'Peranti',
    txt_tj: 'Ditambah',
    txt_gdssb: '{0} jumlah peranti',
    txt_sbbh: 'Kod peranti',
    txt_gjbb: 'Versi perisian',
    txt_tjsj: 'Masa ditambah',
    txt_zdgx: 'Kemas kini automatik',
    txt_gxgj: 'Kemas kini',
    txt_jieb: 'Unbind',
    txt_sbtsxx: 'Terdapat versi baru firmware peranti, klik pada Kemas Kini "Kemas ',
    txt_wjh: 'Unbind',
    txt_lix: 'Di luar talian',
    txt_zaix: 'Dalam talian',
    txt_guz: 'Kegagalan',
    txt_yijieb: 'Ditolak',
    txt_yihuis: 'Kitar semula',
    txt_gxsbgj: 'Kemas kini perisian',
    txt_gxsbgjts: 'Adakah anda mahu menaik taraf peranti??',
    txt_socketdk: 'Komunikasi dengan pelayan tidak ditubuhkan, sila cuba lagi',
    txt_cscgts: 'Kemas kini permintaan berjaya dihantar',
    txt_jbsb: 'Peranti tidak dibind',
    txt_jbsbts: 'Adakah anda mahu menyahikatan peranti?',
    txt_tscg: 'Berjaya',
    txt_zdgxgj: 'Kemas kini firmware secara automatik',
    txt_gxgjts: 'Adakah anda pasti mahu {0} fungsi kemas kini firmware automatik peranti itu?',
    txt_beiz: 'Perkataan',
    txt_qtxbz: 'Sila isi komen',
    txt_bdsbts: 'Aplikasi ini digunakan untuk pengesan pintar kedalaman tayar, sila pastikan peranti adalah betul. .',
    txt_qdksb: 'Sila pasang peranti ',
    txt_dksbts1: '1. Prasana mengikat akan dimulakan selepas peranti baru dihidupkan.',
    txt_dksbts2: '2、Jika peranti telah diikat ke kedai lain sebelum ini, sila klik "nyahbin" dalam menu "Tetapan" peranti untuk menyahikatan peranti.  Selepas peranti melikat, ia akan memasukkan proses pengikatan secara automatik  ',
    txt_yjdksblw: 'Peranti mempunyai kuasa dan disambungkan ke rangkaian',
    txt_xyb: 'Berikut',
    txt_qsclj: 'Sila gunakan peranti pegang tangan untuk mengimbas sambungan kod QR.',
    txt_qscts1: 'Selepas berjaya mengimbas peranti, ia akan memberi "bip" segera dan meminta ',
    txt_qscts2: 'anda untuk mengimbas kod dengan jayanya.',
    txt_sbtssmcg: 'Peranti telah digesa untuk mengimbas kod dengan jayanya.',
    txt_ddsblw: 'Menunggu Rangkaian Peranti',
    txt_zznlbd: 'Cuba mengikat peranti anda',
    txt_qszdd: 'Ini mungkin mengambil puluhan saat, sila tunggu sebentar',
    txt_bdcg: 'Kejayaan',
    txt_tjcg: 'Kejayaan',
    txt_tjcgts: 'Tahniah, peranti berjaya ditambah. Sila Catatan peranti mudah dikenalpasti',
    txt_fhsblb: 'Kembali ke senarai peranti',
    txt_jxtjsb: 'Terus menambah',
    txt_bzmc: 'Perkataan',


    //检测记录
    txt_sx: 'Pilih',
    txt_khsj: 'Nombor telefon',
    txt_cphm: 'Lesen',
    txt_cphm1: 'Lesen',
    txt_clxh: 'Model',
    txt_xgbz: 'Ubah suai nota',
    txt_gtfjl: '{0} rekod',
    txt_jcsj: 'Masa pengesanan',
    txt_jcsj1: 'Masa pengesanan',
    txt_xzkssj: 'Pilih masa mula',
    txt_xzjssj: 'Pilih masa tamat',
    txt_jcjg: 'Keputusan',
    txt_msqk: 'Memakai',
    txt_jygh: 'Ganti',
    txt_zysh: 'Sempadan',
    txt_zcsy: 'Normal',
    txt_zc: 'Normal',
    txt_cz: 'Tetapkan semula',
    txt_qd: 'Pasti',
    txt_jcjgd: 'Keputusan',
    txt_msqkd: 'Memakai',
    txt_sldwd: 'Penjajaran',
    txt_jyghd: 'Ganti',
    txt_zysh: 'Beri perhatian',
    txt_zcsyd: 'Normal',
    txt_xdwd: 'Penjajaran diperlukan',
    txt_xzyd: 'Beri perhatian',
    txt_zcd: 'Normal',
    txt_bgxq: 'Laporkan maklumat',
    txt_ljdy: 'Sambung pencetak',
    txt_fwmd: 'Kedai',
    txt_mddz: 'Alamat kedai',
    txt_jcsb: 'Peranti',
    txt_ddmd: 'Tujuan',
    txt_lic: 'Jarak Tempuh',
    txt_chex: 'Jenis kenderaan',
    txt_jcjyi: 'Cadangan Pemeriksaan',
    txt_ysbs: 'Penerangan Warna',
    txt_ztms: 'Memakai',
    txt_hwms: 'Memakai separa',
    txt_dqscjltx: 'Peringatan Kadar Brek Semasa',
    txt_bgxqts: ' 备注：该测试由独立测试中心天津汽车检测中心进行，所用车辆为奥迪品牌FV7203BECGB型乘用车，轮胎规格为：245/40 R18,轮胎充气压力为：前胎230kpa，后胎220kpa；测试场地为：卡达克盐城测试地；所计算的车辆制动距离的速度范围:从100公里/小时减速至0公里/小时。',
    txt_wxsmgz: 'Sila ikuti akaun rasmi Tyhrhub dengan Wechat',
    txt_hwmsjh: 'Haus seragam',
    txt_zqlun: 'Roda depan kiri',
    txt_zhlun: 'Roda belakang kiri',
    txt_yqlun: 'Roda depan kanan',
    txt_yhlun: 'Roda belakang kanan ',
    txt_pingjunzhi: 'Purata',
    txt_guige: 'Saiz',
    txt_gongli: 'Km',
    txt_ltwjc: 'Tayar tidak dapat dikesan',
    txt_pinpai: 'Jenama',
    txt_ltws: 'Trauma Tayar',
    txt_sewmts: 'Imbas kod QR\nLihat laporan',
    txt_print: 'Print',





    //店员管理
    txt_xz: 'Menambah',
    txt_qy: 'Aktif',
    txt_qyz: 'Bekerja',
    txt_ty: 'lumpuhkan',
    txt_yhzh: 'Pengguna akaun',
    txt_lxfs: 'Telefon mudah alih',
    txt_cjsj: 'Masa penciptaan',
    txt_bjxx: 'Edit',
    txt_xgmm: 'Ubah suai kata laluan',
    txt_bgzt: 'Tukar status',
    txt_qdytjm: 'Adakah anda pasti anda mahu {1} nombor akaun {0}?',
    txt_tjdy: 'Tambah keran',
    txt_bjdyxx: 'Edit maklumat kerani',
    txt_zhxx: 'Maklumat asas',
    txt_ygxm: 'Nama pekerja',
    txt_qtxygxm: 'Sila isikan nama pekerja',
    txt_lxdh: 'Nombor telefon pekerja',
    txt_qtxyglxdh: 'Sila isikan nombor telefon pekerja',
    txt_dxyzm: 'Kod pengesahan SMS',
    txt_qtxdxyzm: 'Kod pengesahan SMS',
    txt_fsdx: 'SMS senden',
    txt_tjzh: 'Tambah akaun',
    txt_baocun: 'Simpan',
    txt_gtgygzh: '{0} akaun pekerja',



    //登录
    txt_qdytcdlm: 'Sedia untuk log keluar？',
    txt_qx: 'Batal',
    txt_dl: 'Masuk',
    txt_qsrzh: 'Sila masukkan ID akaun',
    txt_qsrmm: 'Sila masukkan kata laluan anda',
    txt_zcshzh: 'Daftar akaun',
    txt_shzhwjmm: 'Terlupa burung hantu',
    txt_yzdqmm: 'Sahkan kata laluan semasa',
    txt_szxmm: 'Tetapkan kata laluan baru',
    txt_xgcg: 'Pengubahsuaian Berjaya',
    txt_qtxjmm: 'Sila isikan kata laluan lama',
    txt_yzzcsj: 'Pengesahan nombor telefon',
    txt_qtxxmm: 'Tetapkan kata laluan baru.',
    txt_qzctxxmm: 'Sila masukkan kata laluan sekali lagi',
    txt_lcmmsrbyz: 'Kedua-dua kata laluan tidak konsisten',
    txt_gxnxgcg: 'Tahniah, kata laluan berjaya diubahsuai',
    txt_qljndxmm: 'Sila ingat kata laluan baru anda',
    txt_fhgrzx: 'Kembali ke pusat peribad',
    txt_fsyzm: 'Send SMS',
    txt_qtxzcsjh: 'Sila isikan nombor telefon bimbit',
    txt_qtxtxyzm: 'Sila masukkan kod pengesahan grafik',
    txt_qsryzm: 'Sila masukkan kod pengesahan',
    txt_qszhhmm: 'Sila tetapkan kata laluan baru yang terdiri daripada 6-18 digit dan huruf',
    txt_qzcsrmm: 'Sila masukkan kata laluan sekali lagi',
    txt_lcmmbyz: 'Kedua-dua kata laluan tidak konsisten',
    txt_hdsy: 'Pergi ke rumah',
    txt_zcshh: 'Daftar akaun',
    txt_fhdl: 'Kembali ke log masuk',
    txt_wlqqsb: 'Internet tidak normal, sila cuba semula',
    txt_wczc: 'Pendaftaran Berjaya.',
    txt_wsts: ' Sila selesaikan maklumat lain sebelum mula menggunakan App. ',
    txt_qtxshmc: 'Sila isikan nama pedagang',
    txt_shmc: 'Nama peniaga',
    txt_rgszjd: 'Seperti nombor telefon syarikat, faks, dll.',
    txt_qtlxfs: 'Maklumat hubungan lain',
    txt_kssy: 'Mula menggunakan',
    txt_Pwear1: 'Tidak Sekata',
    txt_open: 'Buka',
    txt_close: 'Tutup',
    txt_srczhdmm: 'Isikan kata laluan baru',
    txt_kcfs: '{0} s',
    txt_xiugai: 'Diubah',
    txt_zzjzsj: 'Memuatkan',
    txt_bjshxx: 'Edit maklumat pedagang',
    txt_chongxinhq: 'Hantar semula',
    txt_gaibangsj: 'Ubah suai telefon bimbit',
    txt_yanzhengjsj: 'Sahkan telefon bimbit lama',
    txt_bangdingxsj: 'Ikat pada telefon bimbit baru',
    txt_yhqsyxsjdl: 'Sila log masuk melalui telefon bimbit baru',



    //登录新
    txt_xzshenfen: 'Sila pilih peranan anda',
    txt_dlrolewz: 'Masuk {0}',
    txt_qsrsjh: 'Sila masukkan nombor telefon anda',
    txt_zhuce: 'Pendaftaran',
    txt_wanjimima: 'Lupa kata laluan',
    txt_wanshandzxx: 'Meningkatkan Maklumat Pengurus Kedai',
    txt_qsrxm: 'Sila masukkan nama anda',
    txt_qsrmdm: 'Sila masukkan nama kedai',
    txt_qsrmdgddh: 'Sila masukkan nombor telefon kedai',
    txt_qsrmddz: 'Sila masukkan alamat kedai',
    txt_qsrgsdz: 'Sila masukkan alamat Saudagar',
    txt_qsrxxdz: 'Sila masukkan alamat kedai',
    txt_tijiaocg: 'Pendaftaran Berjaya',
    txt_qsvbsylwmm: 'Sila tetapkan kata laluan baru yang terdiri ',
    txt_zhucerole: '{0} Berdaftar',
    txt_qsrshh: 'Sila masukkan nombor pedagang',
    txt_qsrdzh: 'Sila masukkan nombor induk kedai',
    txt_wsshhzl: 'Meningkatkan Maklumat Saudagar',
    txt_wsdyhzl: 'Maklumat nombor kedai yang sempurna',
    txt_qsrshm: 'Sila masukkan nama perniagaan (nama syarikat)',
    txt_qsrshz: 'Sila masukkan pemilik perniagaan (orang yang bertanggungjawab)',
    txt_qsrzrqy: 'Sila masukkan bidang tanggungjawab (jabatan kerja)',
    txt_shanghudizhi: 'Alamat Saudagar',
    txt_yhycz: 'Akaun atau nombor telefon wujud',
    txt_qsrzqdzh: 'Sila masukkan Master kedai yang betul',
    txt_qsrzqshh: 'Sila masukkan nombor Saudagar yang betul',
    txt_xzmdcx: 'Pilih Store Pertanyaan',



    //门店
    txt_mendianId: 'ID kedai',
    txt_mendianmc: 'Nama kedai',
    txt_mendiandz: 'Alamat kedai',
    txt_mendiandh: 'Telefon kedai',
    txt_caozuo: 'Operasi',
    txt_mendiangl: 'Kedai',
    txt_gjmendian: '{0} kedai',
    txt_zhengchangyy: 'Terbuka',
    txt_tingye: 'Ditutup',
    txt_gengdxx: 'Lebih banyak',
    txt_dianygl: 'Pengurusan kerani',
    txt_biangzt: 'Perubahan status',
    txt_qdygbzhuangtai: 'Adakah anda pasti anda mahu menukar {0} status kedai kepada {1}?',
    txt_bjmendian: 'Edit',
    txt_xinzenmd: 'Tambah kedai',
    txt_qtxmdmc: 'Sila isikan nama kedai',
    txt_qxzmddz: 'Sila isi alamat kedai',
    txt_qtxxdz: 'Sila isi alamat terperinci kedai',
    txt_xiangxidz: 'Alamat terperinci',
    txt_qtxmddh: 'Sila isikan nombor telefon kedai',
    txt_dzxx: 'Maklumat Pengurus',
    txt_chaungjianmendian: 'Buat kedai',
    txt_mendianxxxx: 'Butiran',
    txt_bianji: 'edit',
    txt_mendianzt: 'Status kedai',

    //商户数据总览
    txt_mendianshuju: 'Menyimpan data',
    txt_chakangdxxbb: 'Semak lebih banyak laporan',
    txt_jczcs: '100 kenderaan diimbas',
    txt_mdpjjc: 'Pemeriksaan purata',
    txt_jdzcl: 'Jumlah aliran kenderaan',
    txt_jcl: 'Kadar pemeriksaan',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: 'Gambaran keseluruhan',
    txt_xiangqbb: 'Butiran',
    txt_xuanzerqckxxsj: 'Pilih tarikh',
    txt_qxzsjd: 'Bitte wählen Sie die Zeit',
    txt_sjdts: 'Anda hanya boleh memilih tempoh yang kurang daripada 30 hari',
    txt_zonglan: 'Gambaran keseluruhan',
    txt_qushi: 'Trend',
    txt_shuliangtj: 'Statistik kuantiti',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: "Trend pemeriksaan Q'ty",
    txt_msqkslqs: 'Trend pemakaian tayar',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: "Jumlah pemeriksaan Q'ty",
    txt_shuliang: "Q'ty",
    txt_zhanbi: '%',
    txt_chankangd: 'Lebih banyak',
    txt_chakanmdxxbb: 'Butiran',


    //国家
    txt_zhongguo: 'China',
    txt_mlxy: 'Malaysia',
    txt_yindu: 'India',
    txt_taiguo: 'Thailand',
    txt_oluosi: 'Rusia',



    txt_taici: 'Unit',
    txt_jianyi: 'Cadangan:',
    txt_jianyineirong: 'Tayar mengalami kehausan tidak normal dan sila dapatkan pemeriksaan lanjut',
    txt_jianyineirongzc: 'Normal',
    txt_bgtixing: 'Peringatan:',
    txt_bgtuxubfnr: 'Peningkatan {0}% dalam jarak brek berdasarkan pakai tayar semasa (anggaran)',
    txt_waishang: 'Trauma Tayar',
    txt_laohua: 'Penuaan',
    txt_gubao: 'Bonjolan',
    txt_xichemeirong: 'Mencuci kereta & Kecantikan',
    txt_weixiubaoyang: 'Penyelenggaraan',
    txt_guenghuanluntai: 'Penggantian Tayar',
    txt_scsltjcy: 'Pengesan tayar dipegang tangan',
    txt_shijiantishi: 'Die Endzeit muss nach der Startzeit liegen',

    txt_qxzclry: 'Kakitangan pemprosesan',

    txt_lf_outworn: 'Luaran tayar depan kiri dipakai daripada dalaman.',
    txt_lf_innerworn: 'Dalaman tayar hadapan kiri dipakai daripada di luar.',
    txt_lf_bothsideworn: 'Kedua-dua belah tayar hadapan kiri adalah dipakai dari pusat.',
    txt_lf_centreworn: 'Pusat tayar hadapan kiri dipakai daripada kedua-dua belah.',
    txt_lb_outworn: 'Yang luar sebelah kiri tayar belakang dipakai daripada dalaman.',
    txt_lb_innerworn: 'Bahagian dalam tayar belakang kiri dipakai daripada luar.',
    txt_lb_bothsideworn: 'Kedua-dua belah tayar belakang kiri adalah dipakai dari pusat.',
    txt_lb_centreworn: 'Pusat tayar belakang kiri dipakai daripada kedua-dua belah.',
    txt_rb_outworn: 'Bahagian luar belakang kanan dipakai daripada dalaman.',
    txt_rb_innerworn: 'Bahagian dalam bahagian belakang kanan dipakai daripada luar.',
    txt_rb_bothsideworn: 'Kedua-dua belah bahagian belakang kanan adalah dipakai dari pusat.',
    txt_rb_centreworn: 'Pusat belakang kanan dipakai daripada kedua-dua belah.',
    txt_rf_outworn: 'Di luar tayar hadapan kanan dipakai daripada dalaman.',
    txt_rf_innerworn: 'Dalaman tayar hadapan kanan dipakai daripada luar.',
    txt_rf_bothsideworn: 'Kedua-dua belah tayar hadapan kanan adalah dipakai dari pusat.',
    txt_rf_centreworn: 'Pusat tayar hadapan kanan dipakai daripada kedua-dua belah pihak.',
    txt_tire_need_replace: 'Status pakaian tayar: Ganti',
    txt_tire_boundary: 'Status pakaian tayar: Sempadan',
    'txt_tire_boundary;': 'Status pakaian tayar: Sempadan',
    txt_alignment_chassis: 'Penjajaran, dan semakan casis adalah disyorkan.',
    txt_wear_uniform: 'Memakai tayar adalah seragam.',
    'txt_wear_uniform;': 'Memakai tayar adalah seragam.',
    txt_do_further_check: 'Sila semak selanjutnya.',
    txt_uneven_check: 'Tayar mempunyai memakai yang tidak sekata, sila lakukan semakan lanjut.',
    'txt_uneven_check;': 'Tayar mempunyai memakai yang tidak sekata, sila lakukan semakan lanjut.',
    txt_tire_rotation: 'Mencadangkan putaran tayar.',
    txt_wear_normal: 'Memakai tayar adalah normal.',
    'txt_wear_normal;': 'Memakai tayar adalah normal.',
    txt_tire: 'tayar',
    txt_yel: 'kenderaan',
    txt_Total_Check: 'diimbas',
    txt_xiazai: 'Muat turun',
    txt_xiazaishibai: 'Muat turun gagal',



    //报告新增 
    'txt_tire_age_5': 'Tayar telah digunakan untuk lebih daripada 5 tahun dan pemeriksaan yang menyeluruh tayar adalah disyorkan',
    'txt_tire_age_3': 'Tayar telah digunakan selama lebih daripada 3 tahun dan pemeriksaan yang menyeluruh tayar adalah disyorkan',
    'txt_tire_age_8': 'Tayar telah digunakan untuk lebih daripada 8 tahun dan pemeriksaan yang menyeluruh tayar adalah disyorkan',
    'txt_tire_age_6': 'Tayar telah digunakan selama lebih daripada 6 tahun dan pemeriksaan yang menyeluruh tayar adalah disyorkan',
    'txt_tire_age_ok': 'Kehidupan tayar biasa',
    'txt_tire_age_ok;': 'Kehidupan tayar biasa',
    'txt_tire_trauma_check': 'Permukaan tayar mempunyai trauma, peperiksaan lanjut adalah disyorkan',
    'txt_install_abnormal_check': 'Pemasangan tayar tidak normal, adalah disyorkan untuk melakukan pemeriksaan lanjut',
    'txt_tire_appearance_ok': 'Tayar berada dalam keadaan baik',
    'trauma_lacerate': 'Berasingan',
    'trauma_dropblock': 'Jatuh',
    'trauma_puncture': 'Tebuk',
    'trauma_scratch': 'Abrasions',
    'txt_tire_age': 'Hayat tayar',
    'txt_tire_appearance': 'Penampilan tayar',
    //未翻译
    txt_plcl: 'Kelompok',
    txt_qbxz: 'Pilih semua',
    txt_scjcjg: 'Data pemeriksaan terakhir',
    txt_ltxhlcgs: 'Tayar kekal anggaran perbatuan',
    txt_ltazhuang: 'Pemasangan tayar:',
    txt_wear_overall: 'Memakai',
    txt_pattern_wear: 'Tidak Sekata',
    txt_ltlcgstm: 'Mengikut keadaan tayar semasa, perbatuan tayar adalah {0} km (anggaran nilai) ',

    txt_yichang: 'Tidak normal',
    txt_qjybjcltazqk: 'Sila semak lagi pemasangan tayar',
    txt_dottx: 'Anggaran hayat tayar',
    txt_dottxjy: 'Tayar telah digunakan selama lebih daripada 3 tahun, pemeriksaan berkala adalah disyorkan',
    txt_danweinian: '(Unit:tahun)',
    txt_danweikm: '(Unit:km)',
    txt_shurujb: "Masukkan '100' untuk melucedkan peranti",
    txt_shuruzqwa: 'Sila masukkan teks sebagai telah digesa',
    txt_myhqdsj: 'Tiada DOT',
    txt_dotjstx: 'Baki masa penggunaan tayar adalah kira-kira {0} hari',
    txt_dotjstx2: 'Tayar telah digunakan selama lebih daripada 5 tahun, sila periksa tayar dengan teliti dan gantikannya jika perlu.  ',
    txt_dotsjztx: '(DOT:tayar tarikh pembuatan)',
    txt_gelie: 'Memotong',
    txt_diaokuai: 'Jatuhkan Blok',
    txt_chaungci: 'Tebuk',
    txt_cashang: 'Awal',
    txt_yichang: 'Tayar tidak normal',
    'txt_tire_need_replace;': 'Status pakaian tayar: Ganti',
    //未翻译
    txt_jishimz: 'Juruteknik',
    txt_ltlcgsnew: 'Tayar remian perbatuan adalah',
    txt_ltlcgsnewin: 'Tayar remian perbatuan adalah',
    txt_pinnate_check: 'Ada pinnato memakai di tayar.  Adalah disyorkan untuk melakukan pemeriksaan lanjut.',
    txt_pinnate_wear: 'Pinnate',
    txt_msjxtx: 'Tayar telah mencapai had, sila gantikannya segera',
    txt_ltfz: 'Songsang dalam dan luar',
    txt_install_check: 'Pemeriksaan pemasangan',
    txt_install_ok: 'Pemasangan biasa',
    LF:'[Roda depan kiri]',
    RF:'[Roda depan kanan]',
    LB:'[Roda belakang kiri]',
    RB:'[Roda belakang kanan]',
    FF:'[Paksi Hadapan]',
    BB:'[Rear Axis]',
    txt_appearance_check: 'Penampilan ban tidak normal, pemeriksaan lanjut disarankan',
    txt_uneven_center: 'Pakaian tidak normal di tengah-tengah tayar. Ia disarankan untuk memeriksa tekanan tayar',
    txt_uneven_out: 'Sisi luar tayar dipakai secara tidak normal. Ia disarankan untuk memeriksa jajaran empat roda dan tekanan tayar',
    txt_pinnate_check: 'Ada pakaian bulu pada tayar. Ia disarankan untuk memeriksa lebih lanjut bahagian chasis',
    txt_uneven_inside: 'Sisi dalaman tayar dipakai secara tidak normal. Ia disarankan untuk memeriksa jajaran empat roda dan tekanan tayar',
    txt_uneven_bothside: 'Pakaian tidak normal pada kedua-dua sisi tayar. Ia disarankan untuk memeriksa jajaran empat roda dan tekanan tayar.',
    txt_msyzljgh:'Ban ini betul-betul dipakai. Sila gantikannya segera.',
    txt_serious_trauma_check:"Ban mempunyai cedera yang serius. Ia dicadangkan untuk menggantikan ban",
    txt_appearance_lookup:"Sila semak penampilan ban",
    txt_wear_lookup :"Sila semak pakaian ban",
    txt_dotscsj:'Masa produksi: {0} ({1} tahun {2} minggu)',
    txt_whqdscsj:'Masa produksi tidak diperoleh',
    purp_tireservice:'Perkhidmatan ban',
    purp_vehicle_inspection:'Pemeriksaan kenderaan', 
    txt_chassis_check :'Pemeriksaan Chassis',
    txt_chassis_ok:'Chasis dalam keadaan baik.',
    txt_chassis_oil:'Penyerap kejutan mempunyai kebocoran minyak. Ia dicadangkan untuk membuat pengesahan lanjut dan menggantikannya jika perlu.',
    txt_chassis_aging :'Gum kepala shaft sudah tua, jadi ia dicadangkan untuk menggantikannya.',
    txt_trauma_eattyre:'makan bayi',
    txt_uneven_eattyre:'disarankan untuk melakukan imbangan dinamik, dan memeriksa penyesuaian empat roda dan sistem penggantian apabila ban makan',
    txt_appearance_eattyre:'disarankan untuk melakukan imbangan dinamik, dan memeriksa penyesuaian empat roda dan sistem penggantian apabila ban makan',
    txt_chassis_eattyre:'disarankan untuk memeriksa penyesuaian empat roda dan sistem penggantian apabila ban makan',
    txt_uneven_high_eattyre:'ika ban rosak serius, ia disarankan untuk menggantikan ban dan memeriksa penyesuaian empat roda dan sistem penggantian',
    txt_appearance_high_eattyre:'jika ban rosak serius, ia dicadangkan untuk melakukan imbangan dinamik dan memeriksa penyesuaian empat roda dan sistem penggantian',
    txt_chassis_high_eattyre:'disarankan untuk memeriksa penyesuaian empat roda dan sistem penggantian jika ban rosak serius',
    txt_chassis_uneven:'jika ban dipakai secara tidak biasa, disarankan untuk memeriksa penyesuaian empat roda dan sistem penggantian',
    txt_pianmoyichang:'pakaian luar biasa ban',
   

    txt_khxm:'Nama pelanggan',
    txt_khyx:'E-mel pelanggan',
  
}


// WEBPACK FOOTER //
// ./src/i18n/malay.js